import React from "react";


function FlipVertical( { onTransform, disabled } ) {

  /**
   * Flips the object vertically when the user clicks the toolbar button.
   *
   * @param {React.MouseEvent} event - The click event object.
   * @returns {void}
   */
  const flipObject = (event) => {
    if (!disabled) {
      onTransform( event, "flip", "Y" );
    }
  };

  return (
    <div
      className="toolbar-button"
      data-test={"image-flip-v"}
      onClick={ flipObject }
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
      <i className="fas fa-arrows-alt-v"></i>
    </div>
  );
}
export default FlipVertical;